"use strict"

import { Data } from '@/lib/core/components/data/data'
import { FieldButton } from '@/lib/core/components/data/form/FieldButton'
import { DataTable } from '@/lib/core/components/data/form/DataTable'
import { FormWindow } from '@/lib/core/components/data/form/FormWindow'

export class Report extends Data {
  #ref
  #dataId
  #register
  #fields
  #Logic
  #custom
  #config
  #item
  #registersList
  #registersFiltereds
  #statusUniq
  #statusTableData
  constructor({ ref, Logic, custom }) {
    super({ module: 'reports', Logic, originClass: Report, custom })
    this.#ref = ref
    this.#Logic = Logic
    this.#custom = custom
  }
  get register() { return this.#register }
  set register(value) { this.#register = value }
  get registersList() { return this.#registersList }
  set registersList(value) { this.#registersList = value }
  get registersFiltereds() { return this.#registersFiltereds }
  set registersFiltereds(value) { this.#registersFiltereds = value }
  async build({ register, fields, customSpecialFields, config }) {
    this.#register = register
    this.#config = { tables: ['table'], ...config }
    const specialFields = {
      voltar: voltarFieldButton,
      copiarTabela: copiarTabelaFieldButton,
      table: ReportDataTable,
      formWindow: FormWindow
    }
    Object.assign(specialFields, customSpecialFields)
    await this.form.build({ register, fields, specialFields })
    await this.start()
    return this
  }
  async start() {
    this.registersList = await this.getRegistersList()
    this.fillFiltersOptions({ registers: this.registersList })
    this.#config.tables.forEach(table => this.form[table].updateData({ registers: this.registersList }))
  }
  filter() {
    const registers = this.#config.filters.reduce((registers, filter) => registers = this.form[filter].filter({ registers }), this.registersList)
    this.#config.tables.forEach(table => this.form[table].updateData({ registers }))
  }
  async getRegistersList() {
    window.showWarning({ text: 'Base de dados do relatório não configurada.' })
    return []
  }
  fillFiltersOptions({ registers }) {
    this.#config?.filters?.forEach(filter => this.form[filter].fillOptions({ registers }))
  }
}

class voltarFieldButton extends FieldButton {
  #form
  #register
  #Logic
  #tableName
  constructor({ form, register, fields, name = 'voltar', Logic, tableName = 'table' }) {
    super({ form, register, fields, name, Logic, originClass: voltarFieldButton })
    this.#form = form
    this.#register = register
    this.#Logic = Logic
    this.#tableName = tableName
  }
  click() {
    this.#form[this.#tableName].tableSwich({ change: -1 })
  }
  showVerify() {
    super.field.show = this.#form[this.#tableName].tableNumber != 0
  }
}

class copiarTabelaFieldButton extends FieldButton {
  #form
  #register
  #Logic
  constructor({ form, register, fields, name = 'copiarTabela', Logic }) {
    super({ form, register, fields, name, Logic, originClass: copiarTabelaFieldButton })
    this.#form = form
    this.#register = register
    this.#Logic = Logic
  }
  click() {
    window.jsf.copyTable({ querySelector: 'table' })
  }
}
export class ReportDataTable extends DataTable {
  #form
  #register
  #Logic
  #tableNumber = 0
  #item = null
  #registersFiltereds = []
  constructor({ form, register, fields, multiline, field, name = 'table', Logic }) {
    super({ register, fields, multiline, field, name, Logic, originClass: ReportDataTable })
    this.#form = form
    this.#register = register
    this.#Logic = Logic
  }
  get config() { return this.getConfig() }
  get currentConfig() { return this.config[this.#tableNumber] }
  get tableNumber() { return this.#tableNumber }
  get item() { return this.#item }
  get registersFiltereds() { return this.#registersFiltereds }
  getConfig() { return {} }
  updateData({ registers }) {
    this.#registersFiltereds = registers
    // this.#registersFiltereds = registers || this.#registersFiltereds
    const items = this.currentConfig?.fill?.({ registersFiltereds: registers, item: this.#item }) || []
    // const items = this.currentConfig?.fill?.({ registersFiltereds: this.#registersFiltereds, item: this.#item }) || []
    const tableColumns = this.currentConfig.headers.map(header => header.value)
    const tablefields = Object.fromEntries(tableColumns.map(column => [column, '']))
    super.items = items.map(register => { return { ...tablefields, ...register } })
    this.configTable()
    this.#form?.voltar?.showVerify()
  }
  updateItem({ item }) {
    const index = this.registersFiltereds.findIndex(register => register._id == item._id)
    this.registersFiltereds[index] = item
  }
  configTable() {
    this.field.headers = this.currentConfig.headers
    this.field.footers = this.currentConfig.footers({ registersFiltereds: this.registersFiltereds })
  }
  clickRow({ item }) {
    this.#item = item
    this.currentConfig?.clickRow?.({ item })
    this.tableSwich({ change: 1 })
  }
  clickCell({ item, header }) {
    this.#item = item
    this.currentConfig?.clickCell?.({ item, header })
    this.tableSwich({ change: 1 })
  }
  tableSwich({ change }) {
    const nextTable = this.#tableNumber + change
    if (this.config[nextTable]) {
      this.#tableNumber = nextTable
      this.#Logic[this.#Logic.name].filter()
    }
  }
}